import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { DengueStageViewControllerDelegate, DengueStageViewController } from "../../Screen/DengueStage/DengueStageViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { DengueStageViewModel } from '../../Screen/DengueStage/DengueStageViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class DengueStageCoordinator implements IndexCoordinatorDelegate, DengueStageViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTableDengueStage(),
            this.routeFormDengueStage()
        ]
    }

    private routeTableDengueStage(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepfasedengue")
        return (<ProtectedRoute requiredPermissions={['dengue.fase.*']} path="/:base/dengue/estagio" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.fase.adicionar',
                    edit: 'dengue.fase.editar',
                    delete: 'dengue.fase.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Estágio Dengue"}
            />)
        }} />)
    }

    private routeFormDengueStage(): JSX.Element {
        var viewModel = new DengueStageViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.fase.adicionar', 'dengue.fase.editar']} path="/:base/dengue/estagio/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<DengueStageViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk} />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepfasedengue") {
            navigation.history.push(`estagio/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepfasedengue") {
            navigation.history.push(`estagio/cad/${idSelection}`);
            return;
        }
    }

}